import React from "react";

const Error = () => {
  return (
    <div className="text-center">
      <h1 className="font-extrabold text-9xl py-10">404</h1>
      <h1>PAGE NOT READY YET</h1>;
    </div>
  );
};

export default Error;
